<template>
  <li class="dropdown" @mouseenter="clearNewsNotifications">
    <a class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
      <i class="fa fa-fw fa-bell-o" style="font-size:1.6rem"></i>
      <span v-if="newNotification > 0" class="bell-badge"> {{ newNotification }}</span>
    </a>
    <ul class="dropdown-menu"
      :style="{ ...(hasNotifications) ? { width: '30em' } : {}, 
	  			...(notifications.length >= 3) ? {height: screeAvailHeight + 'px'} : {}, 
				'overflow-y': (notifications.length >= 3) ? 'scroll' : 'hidden' }"
	  ref="dropdown"
    >
      <li v-if="!hasNotifications" class="dropdown-header"> 
        Nenhuma notificação recebida no momento
      </li>
      <li v-else 
        class="dropdown-header" 
      > 
        Notificações gerais
      </li>

	  <template v-for="(notification, i) in notifications">
		<base-notifications
			v-if="notifications.length > 0 && notification.typeAlert === 'balance_alert'"
			fa_icon="fa-3x fa-dollar"
			:key="i"
		>
			<BalanceAlertNotification 
				:key="i"
				:alert="notification"
				@decreaseNotification="decreaseNotification"
			/>
		</base-notifications>

		<base-notifications
			v-if="notifications.length > 0 && notification.typeAlert === 'paid_pix'"
			fa_icon="fa-3x fa-dollar"
			:key="i"
		>
			<PixNotification
				:key="i"
				:pix="notification"
				@decreaseNotification="decreaseNotification"
			/>

		</base-notifications>

		<base-notifications
			v-if="notifications.length > 0 && notification.typeAlert === 'alert-panel'"
			fa_icon="fa-2x fa-warning"
			:key="i"
		>
			<alert-panel-notification
				:alert="notification"
				@decreaseNotification="decreaseNotification"
			/>
		</base-notifications>

		<base-notifications
			v-if="notifications.length > 0 
				&& (notification.typeAlert === 'certificate-received' || notification.typeAlert === 'certificate-creation-failed')"
			fa_icon="fa-3x fa-file-code-o"
			:key="i"
		>
			<certificate-ready-notification
				:certificate="notification"
				@decreaseNotification="decreaseNotification"
			/>
		</base-notifications>

		<base-notifications
			v-if="notifications.length > 0
				&& notification.typeAlert === 'client_added' || notification.typeAlert === 'status_changed'"
			fa_icon="fa-2x fa-users"
			:key="i"
		>
			<notify-user-on-client
				:notifyUser="notification"
				@decreaseNotification="decreaseNotification"
			/>
		</base-notifications>

		<base-notifications
			v-if="notifications.length > 0
				&& notification.typeAlert === 'notify_boleto_payment'"
			fa_icon="fa-2x fa-money"
			:key="i"
		>
			<notify-boleto-payment
				:notify="notification"
				@decreaseNotification="decreaseNotification"
			/>
		</base-notifications>
	  </template>
    </ul>
  </li>
</template>

<script>
  import BalanceAlertNotification from '../general_notification_components/BalanceAlertNotification.vue'
  import PixNotification from '../general_notification_components/PixNotification.vue'
  import CertificateReadyNotification from '../general_notification_components/CertificateReadyNotification.vue'
  import BaseNotifications from '../general_notification_components/BaseNotifications.vue'
  import AlertPanelNotification from '../general_notification_components/AlertPanelNotification.vue'
  import NotifyUserOnClient from '../general_notification_components/NotifyUserOnClient.vue'
  import NotifyBoletoPayment from '../general_notification_components/NotifyBoletoPayment.vue'
  import { mapState, mapActions } from 'vuex'
  import _ from 'lodash'
  export default {
    components: { BalanceAlertNotification, PixNotification, CertificateReadyNotification, BaseNotifications, AlertPanelNotification, NotifyUserOnClient, NotifyBoletoPayment },
    name: 'GeneralNotifications',
    data () {
      return {
        lodash: _,
        screeAvailHeight: 0
      }
    },
    watch: {
      notifications (to, from) {
        this.updateScreenHeigthForDropdowMenu()
      }
    },
    mounted () {
      this.listenEvents()
      this.updateScreenHeigthForDropdowMenu()
    },
    computed: {
      ...mapState({
        newNotification: state => state.notifictionsGeneral,
        user: state => state.user,
        notifications: state => state.notifications
      }),
      hasNotifications () {
        return this.notifications.length > 0
      }
    },
    methods: {
      updateScreenHeigthForDropdowMenu () {
        this.screeAvailHeight = this.notifications.length > 0 ? window.screen.availHeight - 200 : 40
        let dynamicHeigth = (this.getElementHeigth() > 0) ? this.getElementHeigth() : this.screeAvailHeight
        if (dynamicHeigth < this.screeAvailHeight) this.screeAvailHeight = dynamicHeigth
      },
      getElementHeigth () {
        const elementOfList = this.$refs.dropdown
        const elementOfListUl = elementOfList.getElementsByClassName('card')
        let heightCard = 0
        if (elementOfListUl.length > 0) {
          this.lodash.forEach(elementOfListUl, function (card, key) {
            heightCard += card.offsetHeight
          })
        }
        return heightCard
      },
      listenEvents () {
        let eventsMap = {
          '.App\\Events\\NotifyUserOnClientStatusChange': { method: 'addNotifications', notifyAll: false },
          '.App\\Events\\NotifyUserOnClientCreation': { method: 'addNotifications', notifyAll: false },
          '.App\\Events\\BalanceAlertNotification': { method: 'addNotifications', notifyAll: true },
          '.App\\Events\\PixPaymentConfirmed': { method: 'showNotificationPaidPix', notifyAll: true },
          '.App\\Events\\CertificateReceived': { method: 'addNotifications', notifyAll: true },
          '.App\\Events\\CertificateCreationFailed': { method: 'addNotifications', notifyAll: true },
          '.App\\Events\\NotifyBoletoPayment': { method: 'addNotifications', notifyAll: true }
        }
        Object.keys(eventsMap).forEach(event => {
          window.Channel.listen(event, (e) => {
            const eventScoped = eventsMap[event]
            if (this[eventScoped.method] && typeof this[eventScoped.method] === 'function') {
              if (eventScoped.notifyAll) {
                this[eventScoped.method](e)
              } else {
                if (this.user.id !== e.actionedByUser.id) this[eventScoped.method](e)
              }
            }
          })
        })
        window.Channel.alertPanel.listen('.App\\Events\\RestrictionNotification', (e) => {
          this.addNotificationRestriction(e)
        })
      },
      showNotificationPaidPix (event) {
        if (this.$route.name !== 'finances_dashboard') {
          this.addNotifications(event)
        }
      },
      addNotifications (event) {
        this.changeNotificationsGeneral('add')
        this.pushNotifications(event)
      },
      addNotificationRestriction (event) {
        let hasCompanyCurrent = event.data.company.id === this.user.company.id
        if (!hasCompanyCurrent) {
          this.changeNotificationsGeneral('add')
          this.pushNotifications(event)
        }
      },
      decreaseNotification (event) {
        this.decreaseNotifications(event)
      },
      clearNewsNotifications () {
        setTimeout(() => {
          this.changeNotificationsGeneral('clear')
        }, 500)
      },
      ...mapActions([
        'changeNotificationsGeneral',
        'pushNotifications',
        'decreaseNotifications'
      ])
    }
  }
</script>

<style scoped>
  .partial-header.navbar .bell-badge {
    margin-left: -09px;
  }
</style>


// WEBPACK FOOTER //
// GeneralNotifications.vue?11800bcc